<template>
  <div class="print-header">
    <b-row>
      <b-col class="col-print-3">
        <img
          src="@/assets/images/common/drip-logo-tagline.svg"
          alt="Drip Capital"
          class="print-main-logo"
        />
      </b-col>
      <b-col class="col-print-9 text-right">
        <p>
          <strong>{{ $t('common.address.us.company') }}</strong
          ><br />
          {{ $t('common.address.us.line1') }}<br />
          {{ $t('common.address.us.line2') }}<br />
          {{ $store.state.constants.phoneNumber.us }}<br />
          <span class="grey">{{ $t('common.address.website') }}</span
          ><br />
          <br />
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="col-print-6">
        <p>
          <b>{{ $t('common.print.to') }}</b
          ><br />
          {{ invoice.exporter.company }}<br />
          {{ invoice.exporter.address }}, {{ invoice.exporter.country }}<br />
          <template v-if="invoiceForMexico">{{
            invoice.exporter.rfc_number
          }}</template>
        </p>
      </b-col>
      <b-col
        class="col-print-6 text-right"
        :class="{ 'd-print-none': invoiceForMexico }"
      >
        <p>
          {{ $t('common.print.local') }}<br />
          <b>{{ $t('common.address.local.company') }}</b
          ><br />
          {{ $t('common.address.local.line1') }}<br />
          {{ $t('common.address.local.line2') }}<br />
          {{ $store.state.constants.phoneNumber.in }}<br />
        </p>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  props: ['invoice'],
  computed: {
    invoiceForMexico() {
      return this.invoice.exporter.country === 'Mexico'
    }
  }
}
</script>
